import Swal from "sweetalert2";

const baseToast = {
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timerProgressBar: true,
};

export const showError = (title) => {
  Swal.fire({
    ...baseToast,
    icon: "error",
    title,
    timer: 5000,
  });
};

export const showSuccess = (title) => {
  Swal.fire({
    ...baseToast,
    icon: "success",
    title,
    timer: 5000,
  });
};

export const showWarning = (title) => {
  Swal.fire({
    ...baseToast,
    icon: "warning",
    title,
    timer: 3000,
  });
};
